import React from 'react'
import { Outlet, Navigate } from 'react-router-dom'

const ServiceProvidersProtectedRoutes = () => {
    let isServiceProvderLoggedIn = 'loggedIn' && 'serviceProvider';
    return (
        <>
            {
                isServiceProvderLoggedIn ? <Outlet /> : <Navigate to={'/'} />
            }
        </>
    )
}

export default ServiceProvidersProtectedRoutes